export default "__VITE_ASSET__0ec111cf__"